import { Component } from '@angular/core';
import { ContainerComponent } from '../../../shared/components/container/container.component';

@Component({
  selector: '[autoantibodies]',
  imports: [ContainerComponent],
  templateUrl: './autoantibodies.component.html',
  styleUrl: './autoantibodies.component.scss'
})
export class AutoantibodiesComponent {

}
